/* eslint-disable @nx/enforce-module-boundaries */
import { useEffect, useMemo, useRef, useState } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
  type MRT_TableOptions,
} from 'material-react-table';
import {
  Typography,
  TextField,
  Box,
  InputAdornment,
  useMediaQuery,
  Menu,
  MenuItem,
  Pagination,
  PaginationItem,
  Button,
  useTheme,
  Tabs,
  Tab,
} from '@mui/material';
import { MRT_Cell } from 'material-react-table';
import searchIcon from 'packages/novous_web/src/assets/icons/Icon.svg';
import filterIcon from 'packages/novous_web/src/assets/icons/Filter.svg';
import add from 'packages/novous_web/src/assets/icons/PlusWhiteStroke.svg';
import documentIcon from 'packages/novous_web/src/assets/icons/document.svg';
import editIcon from 'packages/novous_web/src/assets/icons/edit.svg';
import downloadIcon from 'packages/novous_web/src/assets/icons/download.svg';
import deleteIcon from 'packages/novous_web/src/assets/icons/delete1.svg';
import download from 'packages/novous_web/src/assets/icons/download.svg';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import Custom from 'packages/novous_web/src/assets/icons/CustomBlue.svg';
import FilterDataModel from 'packages/novous_web/src/common/components/FilterDataModal';
import CustomiseTableModal from 'packages/novous_web/src/common/components/CustomiseTable';
import CallingModal from 'packages/novous_web/src/common/components/CallingModal';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import useDebounce from 'packages/novous_web/src/hooks/useDebounce';
import DownloadData from 'packages/novous_web/src/common/components/DownloadData';
// import DriverAlertDashboard from "../Dashboard";
import dayjs from 'dayjs';
import DateRangeFilter from 'packages/novous_web/src/common/components/DateRange';
import calendar from 'packages/novous_web/src/assets/icons/calendar.svg';
import arrow from 'packages/novous_web/src/assets/icons/Arrow.svg';
import shareCoaching from 'packages/novous_web/src/assets/icons/ShareCoaching.svg';
import downloadWhiteIcon from 'packages/novous_web/src/assets/icons/downloadWhiteIcon.svg';
import reset from '../../../../../../assets/icons/Reset.svg';

interface Driver {
  empId: string;
  driverName: string;
  driverScore: number;
  vehicleRegNo: string;
  phone: string;
  totalAlerts: number;
  topAlerts: string;
  driverId: string;
}

type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};

interface DriverDataTableProps {
  handleTile: (data: ColumnObjType) => void;
}

const DriverAlertDataTable = () => {
  const today = dayjs();
  const theme = useTheme();
  const [searchQuery, setSearchQuery] = useState('');
  const [data, setData] = useState<Driver[]>([]);
  const [filteredData, setFilteredData] = useState<Driver[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedDriver, setSelectedDriver] = useState<any>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const previousStartDate = location.state?.startDate || '';
  const previousEndDate = location.state?.endDate || '';
  const previousSelectedDuration = location.state?.selectedDuration || 'Today';
  const isSmallScreen = useMediaQuery('(max-width:850px)');
  const [currentPage, setCurrentPage] = useState(1);
  const paginatedArr = useRef<any[]>([null]);
  const [isCustomiseModalOpen, setIsCustomiseModalOpen] = useState(false);
  const [isFilterModel, setIsFilterModelOpen] = useState(false);
  const handleOpen = () => setIsCustomiseModalOpen(true);
  const {
    data: DriversData,
    error: DriversError,
    loading: DriversLoading,
    fetchData: fetchDriversData,
  } = useAxios<{ data: { driverLists: any[]; lastEvaluatedKey: null } }>(
    `${API_ENDPOINTS.alarm.DRIVER_ALERT_LIST}`,
    'POST',
  );

  const {
    data: DriversDownloadData,
    error: DriversDownloadError,
    loading: DriversDownloadLoading,
    fetchData: fetchDriversDownloadData,
  } = useAxios<{ data: { drivers: any[]; lastEvaluatedKey: null } }>(
    `${API_ENDPOINTS.directories.DRIVER_DOWNLOAD}`,
    'POST',
    'blob',
  );

  const { user } = useAuth();
  const debouncedSearchQuery = useDebounce(searchQuery, 500);
  const [columnObj, setColumnObj] = useState<ColumnObjType>({
    driverId: { name: 'Employee ID', status: true },
    driverName: { name: 'Driver Name', status: true },
    phoneNumber: { name: 'Contact', status: true },
    topAlerts: { name: 'Top three alert types received', status: true },
    totalAlerts: { name: '#Alerts Received', status: true },
    actions: { name: 'Actions', status: true },
  });
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);

  const [startDate, setStartDate] = useState(previousStartDate);
  const [endDate, setEndDate] = useState(previousEndDate);
  const [tilesObj, setTilesObj] = useState<ColumnObjType>({
    Stat1: { name: 'Under Coaching', status: true },
    Stat2: { name: 'Coaching Required', status: true },
    Stat3: { name: 'Coaching Completed', status: true },
    Stat4: { name: 'Avg Alerts Per Driver', status: true },
  });
  const dateRangeArr = ['Today', 'Yesterday', '7 Days', '15 Days', '30 Days', 'Custom Range'];
  const scoreData = [
    { name: 'Score: 0 - 70', value: 240 },
    { name: 'Score: 71 - 90', value: 560 },
    { name: 'Score: 91 - 100', value: 202 },
  ];
  const [activeTab, setActiveTab] = useState<'systemSelected' | 'userTaggedCoachable'>('systemSelected');
  const [selectedDuration, setSelectedDuration] = useState(previousSelectedDuration || dateRangeArr[0]);
  const [calendarAnchorEl, setCalendarAnchorEl] = useState<null | HTMLElement>(null);
  const [calendarMenuAnchorEl, setCalendarMenuAnchorEl] = useState<null | HTMLElement>(null);
  const handleFilterClose = () => setIsFilterModelOpen(false);
  const getDateRange = (range: string) => {
    const today = dayjs();
    let startDate, endDate;

    switch (range) {
      case 'Today':
        startDate = today.format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      case 'Yesterday':
        startDate = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
        endDate = startDate;
        break;
      case '7 Days':
        startDate = dayjs().subtract(6, 'day').format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      case '15 Days':
        startDate = dayjs().subtract(14, 'day').format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      case '30 Days':
        startDate = dayjs().subtract(29, 'day').format('YYYY-MM-DD');
        endDate = today.format('YYYY-MM-DD');
        break;
      default:
        startDate = '';
        endDate = '';
    }
    return { startDate, endDate };
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setCalendarMenuAnchorEl(event.currentTarget);
    setCalendarAnchorEl(event.currentTarget);
  };

  const handleCalendarClose = () => {
    setShowDatePicker(false);
    // setStartDate("");
    // setEndDate("");

    // setSelectedDuration(dateRangeArr[0]);
    setCalendarAnchorEl(null);
  };

  const handleClose = (value?: string) => {
    console.log('Selected Value:', value);

    if (value) {
      // Only reset dates if changing FROM custom range TO another option
      if (selectedDuration === 'Custom Range' && value !== 'Custom Range') {
        const { startDate: newStartDate, endDate: newEndDate } = getDateRange(value);
        setStartDate(newStartDate);
        setEndDate(newEndDate);
      }

      setSelectedDuration(value);
      setShowDatePicker(value === 'Custom Range');

      // If selecting Custom Range again, don't reset the dates - keep existing values
      if (value === 'Custom Range') {
        setCalendarAnchorEl(anchorEl); // Keep the anchor for the date picker
      }
    }

    setAnchorEl(null);
  };
  useEffect(() => {
    if (DriversDownloadData) {
      try {
        if (DriversDownloadData instanceof Blob) {
          const url = window.URL.createObjectURL(DriversDownloadData);
          const a = document.createElement('a');
          a.href = url;
          let extension = selectedFormat.toLowerCase();
          if (extension === 'excel') {
            extension = 'xlsx'; // Use xlsx for Excel format
          }

          const fileName = `drivers_data.${extension}`;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        } else {
          console.error('Invalid response format. Expected a Blob.');
        }
      } catch (error) {
        console.error('Error downloading file:', error);
      } finally {
        setIsDownloadModalOpen(false);
      }
    }
  }, [DriversDownloadData]);

  const handleDownloadModalClose = () => {
    setIsDownloadModalOpen(false);
  };
  const [selectedFormat, setSelectedFormat] = useState<string>('pdf');
  const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedFormat(event.target.value);
  };

  const handleDownload = async () => {
    fetchDriversDownloadData({
      fleetId: user?.customer_id,
      fileType: selectedFormat,
    });
  };

  useEffect(() => {
    if (DriversData?.data?.lastEvaluatedKey) {
      if (paginatedArr?.current?.length === currentPage) {
        paginatedArr.current.push(DriversData.data.lastEvaluatedKey);
      }
    }
    if (DriversData?.data) {
      const driverListData: Driver[] = DriversData?.data?.driverLists?.map((driver: any) => ({
        empId: driver?.empId ?? 'NA',
        driverName: driver?.driverName ?? 'NA',
        driverScore: driver?.driverScore ?? 0,
        topAlerts: driver?.topAlerts ?? 'NA',
        totalAlerts: driver?.totalAlerts ?? 0,
        vehicleRegNo: driver?.driverRegisterId ?? 'NA',
        phone: driver?.phoneNumber ?? 'NA',
        driverId: driver.driverId,
      }));
      setData(driverListData);
    }
  }, [DriversData]);

  useEffect(() => {
    if (debouncedSearchQuery) {
      const query = searchQuery.toLowerCase();
      const filtered = data.filter(
        (driver) =>
          driver.driverName.toLowerCase().includes(query) ||
          driver.empId.toLowerCase().includes(query) ||
          driver.vehicleRegNo.toLowerCase().includes(query),
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(data);
    }
  }, [debouncedSearchQuery, data]);

  const handleOpenMenu = (event: React.MouseEvent<HTMLSpanElement>, driver: Driver) => {
    setAnchorEl(event.currentTarget);
    setSelectedDriver(driver);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSelectedDriver(null);
  };

  const totalPages = paginatedArr?.current?.length;

  const handleViewDriver = () => {
    navigate(`/directories/drivers/${selectedDriver.driverId}`);
    handleCloseMenu();
  };

  //   useEffect(() => {
  //     handleTile(tilesObj)
  //   }, [tilesObj])
  const handleEditDriver = () => {
    alert(`Editing driver ${selectedDriver?.driverName}`);
    handleCloseMenu();
  };

  const handleDownloadDriverData = () => {
    setIsDownloadModalOpen(true);
    handleCloseMenu();
  };

  const handleDeleteDriver = () => {
    const confirmDelete = window.confirm(`Are you sure you want to delete ${selectedDriver?.driverName}?`);
    if (confirmDelete) {
      alert(`Deleted ${selectedDriver?.driverName}`);
    }
    handleCloseMenu();
  };
  useEffect(() => {
    fetchDriversData({
      fleetId: user?.customer_id,
      fleetAdminId: user?.parentId,
      lastEvaluatedKey: null,
      startDate: startDate,
      endDate: endDate,
    });
  }, [user, startDate, endDate, selectedDuration]);
  useEffect(() => {
    const { startDate: newStartDate, endDate: newEndDate } = getDateRange(selectedDuration);
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  }, [selectedDuration]);
  const handlePageChange = (event: React.ChangeEvent<unknown>, page: number) => {
    if (page !== 1) {
      fetchDriversData({
        fleetId: user?.customer_id,
        lastEvaluatedKey: paginatedArr.current[page - 1],
      });
    } else {
      fetchDriversData({ fleetId: user?.customer_id, lastEvaluatedKey: null });
    }
    setCurrentPage(page);
  };

  const allColumns: MRT_ColumnDef<Driver>[] = useMemo(() => {
    return [
      {
        accessorKey: 'driverId',
        header: 'Coaching Name',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '8px', overflow: 'hidden' },
        },
        Cell: ({ cell, row }: { cell: MRT_Cell<Driver>; row: any }) => (
          <Typography
            className="truncate"
            variant="body2"
            fontWeight={400}
            noWrap
            sx={{
              fontFamily: 'Inter Tight',
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: '21px',
              letterSpacing: '0%',
              textDecoration: 'underline',
              textDecorationStyle: 'solid',
              textDecorationOffset: '0%',
              textDecorationThickness: '0%',
              textDecorationSkipInk: 'auto',
              cursor: 'pointer',
            }}
            onClick={() => {
              const params = new URLSearchParams();
              console.log('startDate', startDate);
              console.log('endDate', endDate);
              console.log('selectedDuration', selectedDuration);
              if (startDate && endDate) {
                params.set('startDate', startDate);
                params.set('endDate', endDate);
              }
              if (selectedDuration) {
                params.set('selectedDuration', selectedDuration);
              }
              params.set('driverId', row.original.driverId);
              params.set('driverName', row.original.driverName);
              params.set('employeeId', row.original.driverId);

              navigate(`/alarm/driver-alert-dashboard?${params.toString()}`);
            }}
          >
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'driverName',
        header: 'Date Shared',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '8px', overflow: 'hidden' },
        },
        Cell: ({ cell }: { cell: MRT_Cell<Driver> }) => (
          <Typography className="truncate" variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'phoneNumber',
        header: 'Event',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '8px', overflow: 'hidden' },
        },
        Cell: ({ cell }: { cell: MRT_Cell<Driver> }) => (
          <Typography className="truncate" variant="body2" fontWeight={400} noWrap>
            {cell.getValue<number>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'topAlerts',
        header: 'Status',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '8px', overflow: 'hidden' },
        },
        Cell: ({ cell }: { cell: MRT_Cell<Driver> }) => (
          <Typography className="truncate" variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'totalAlerts',
        header: 'Date Completed',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '8px', overflow: 'hidden' },
        },
        Cell: ({ cell }: { cell: MRT_Cell<Driver> }) => (
          <Typography className="truncate" variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'actions',
        header: 'Completion %',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '8px', overflow: 'hidden' },
        },
        Cell: ({ row }: { row: MRT_Cell<Driver>['row'] }) => (
          <Typography
            variant="body2"
            fontWeight={700}
            color="primary"
            sx={{ cursor: 'pointer' }}
            onClick={(e) => handleOpenMenu(e, row.original)}
          >
            Actions
          </Typography>
        ),
      },
      {
        accessorKey: 'actions',
        header: 'Actions',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 180,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '8px', overflow: 'hidden' },
        },
        Cell: ({ row }: { row: MRT_Cell<Driver>['row'] }) => (
          <Typography
            variant="body2"
            fontWeight={700}
            color="primary"
            sx={{ cursor: 'pointer' }}
            onClick={(e) => handleOpenMenu(e, row.original)}
          >
            Actions
          </Typography>
        ),
      },
    ].filter((column) => columnObj[column.accessorKey as keyof ColumnObjType]?.status);
  }, [columnObj, isSmallScreen, startDate, endDate, selectedDuration]);

  const columns: MRT_ColumnDef<Driver>[] = useMemo(() => {
    return allColumns.filter((column) => {
      const key = column.accessorKey as keyof ColumnObjType;
      return columnObj[key]?.status;
    });
  }, [allColumns, columnObj]);

  const tableOptions: MRT_TableOptions<Driver> = {
    columns,
    data: filteredData?.length > 0 ? filteredData : [],
    enablePagination: false,
    enableColumnFilters: false,
    enableSorting: false,
    enableGlobalFilter: false,
    enableDensityToggle: false,
    enableHiding: false,
    enableBottomToolbar: false,
    enableTopToolbar: false,
    enableFullScreenToggle: false,
    enableColumnResizing: false,
    enableToolbarInternalActions: false,
    muiTableBodyProps: {
      sx: {
        padding: 0,
        margin: 0,
      },
    },
  };

  const table = useMaterialReactTable(tableOptions);
  const handleCalendarMenuClose = (value?: string) => {
    console.log('Selected Value:', value);

    if (value) {
      setSelectedDuration(value);
      setShowDatePicker(value === 'Custom Range');
      const { startDate: newStartDate, endDate: newEndDate } = getDateRange(value);
      setStartDate(newStartDate);
      setEndDate(newEndDate);
    }

    setCalendarAnchorEl(null);
    setCalendarMenuAnchorEl(null);
  };
  const handleMenuClose = () => {
    setCalendarAnchorEl(null);
    setCalendarMenuAnchorEl(null);
  };
  const handleFilterSave = (data: any) => {
    fetchDriversData({
      fleetId: user?.customer_id,
      startDate: startDate,
      endDate: endDate,
      lastEvaluatedKey: null,
      ...(data.group && { vehicleGroup: data.group }),
      // ...(data.vehicle && { vehicleId: data.vehicleId }),
    });
  };
  const handleReset = () => {
    setSearchQuery('');
  };
  return (
    <>
      <div className="flex flex-col gap-4 w-full mt-4">
        <div className="flex justify-between gap-4 sm:flex-row flex-col"></div>
        <div style={{ width: '25%', alignItems: 'center' }}>
          <Tabs
            value={activeTab}
            onChange={(e, newVal) => setActiveTab(newVal)}
            sx={{
              borderRadius: '8px',
              padding: '4px',
              backgroundColor: theme.palette.selected,
              '& .MuiTab-root': {
                // Applies to all tabs
                color: 'black !important', // Constant black text
              },
            }}
            TabIndicatorProps={{ style: { display: 'none' } }}
          >
            <Tab
              label="System Selected"
              value="systemSelected"
              sx={{
                ...(activeTab === 'systemSelected' && {
                  backgroundColor: theme.palette.background.default,
                  borderRadius: '8px',
                  fontWeight: 600,
                  padding: '8px 16px',
                  boxShadow: '0px 4px 6px #5547DD1A',
                }),
              }}
            />
            <Tab
              label="User Tagged Coachable"
              value="userTaggedCoachable"
              sx={{
                ...(activeTab === 'userTaggedCoachable' && {
                  backgroundColor: theme.palette.background.default,
                  borderRadius: '8px',
                  fontWeight: 600,
                  padding: '8px 16px',
                  boxShadow: '0px 4px 6px #5547DD1A',
                }),
              }}
            />
          </Tabs>
        </div>
        <MaterialReactTable table={table} />
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
          <MenuItem onClick={handleViewDriver} sx={{ padding: '12px 16px' }}>
            <img src={documentIcon} alt="View Driver" style={{ marginRight: 8 }} />
            <Typography variant="body2" fontWeight={600}>
              View Driver
            </Typography>
          </MenuItem>
          <MenuItem onClick={handleEditDriver} sx={{ padding: '12px 16px' }}>
            <img src={shareCoaching} alt="Edit Driver" style={{ marginRight: 8 }} />
            <Typography variant="body2" fontWeight={600}>
              Share Coaching
            </Typography>
          </MenuItem>
          <MenuItem onClick={handleDownloadDriverData} sx={{ padding: '12px 16px' }}>
            <img src={downloadIcon} alt="Download Driver" style={{ marginRight: 8 }} />
            <Typography variant="body2" fontWeight={600}>
              Download Driver Data
            </Typography>
          </MenuItem>
          {/* <MenuItem onClick={handleDeleteDriver} sx={{ padding: "12px 16px" }}>
            <img
              src={deleteIcon}
              alt="Delete Driver"
              style={{ marginRight: 8 }}
            />
            <Typography variant="body2" color="error" fontWeight={600}>
              Delete Driver
            </Typography>
          </MenuItem> */}
        </Menu>
        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            shape="rounded"
            color="primary"
            siblingCount={0}
            boundaryCount={0}
            renderItem={(item) => {
              if (item.type === 'page' && item.page !== null && item.page > currentPage) {
                return null;
              }
              return <PaginationItem {...item} />;
            }}
          />
        </Box>
      </div>

      <DownloadData
        isDownloadModalOpen={isDownloadModalOpen}
        handleDownloadModalClose={handleDownloadModalClose}
        selectedFormat={selectedFormat}
        handleFormatChange={handleFormatChange}
        handleDownload={handleDownload}
        modalTitle="Download Drivers Data"
        modalDescription="Please select a file format for your download."
        formatLabel="Format"
        formatExcelLabel="Excel"
        formatCsvLabel="CSV"
        formatPdfLabel="PDF"
        cancelButtonText="Cancel"
        downloadButtonText="Download"
      />

      <CustomiseTableModal
        open={isCustomiseModalOpen}
        onClose={() => setIsCustomiseModalOpen(false)}
        onReset={() => console.log('Reset clicked!')}
        title="Customize Your Table"
        description="Select and arrange table columns as you prefer."
        columnObj={columnObj}
        setColumnObj={setColumnObj}
        tilesObj={tilesObj}
        setTilesObj={setTilesObj}
      />

      <FilterDataModel
        open={isFilterModel}
        // onClose={() => setIsFilterModelOpen(false)}
        onReset={() => console.log('Reset filter!')}
        // handleFilterSave={(filters) => console.log("Save filters:", filters)}
        title="Filter Drivers"
        description="Refine the driver list with these filters."
        onClose={handleFilterClose}
        handleFilterSave={handleFilterSave}
        showTripStatus={false}
      />
    </>
  );
};

export default DriverAlertDataTable;
